import RestApiModel from "@/api/Model/RestApiModel";

class Log extends RestApiModel {
  static getResourceEndpoint() {
    return '/logs';
  }
}

export default Log;
